export { useNavCategory_unstable as useNavCategory } from '@fluentui/react-nav';
